class SelectSearchable extends SelectBase {

    constructor(el) {
        super(el, 'placeholder', true);
        this.tagsEls = {};
        this.classHideItem = `${this.baseClass}__item--hide`;
        this.classEmpty = `${this.baseClass}--empty`;
        this.tagsEl = this.el.querySelector(`.${this.baseClass}__tags`);
        this.trigger.addEventListener('input', this.filter.bind(this));
    }

    filter() {
        const val = this.trigger.value.toLowerCase().trim();
        let showCount = 0;
        this.listEls.forEach((el) => {
            const elVal = el.innerText.toLowerCase().trim();
            const show = elVal.includes(val);
            el.classList.toggle(this.classHideItem, !show)
            if(show) {
                showCount++;
            }
        });
        this.el.classList.toggle(this.classEmpty, !showCount);
    }

    handleSelect(el) {
        const value = el.dataset.value;
        if(super.handleSelect(el)) {
            this.createElActive(el.innerHTML, value, el);
        }
        else {
            this.tagsEls[value].remove();
        }
    }

    createElActive(name, value, el) {
        const div = document.createElement('div');
        div.classList.add('SelectSearchable__tag');
        div.innerHTML = name;
        this.tagsEl.append(div);
        div.addEventListener('click', () => {
            div.remove();
            super.handleSelect(el);
        });
        this.tagsEls[value] = div;
    }
}

document.querySelectorAll('.SelectSearchable').forEach((el) => {
    new SelectSearchable(el);
})
